import { Plus, Pencil, Trash2 } from "lucide-react";
import { EMPTY_LEAGUE, joinList, leagueStatusBadge } from "./shared";

export default function LeaguesTab({ ctx }) {
  const { leagues, setEditing, deleteLeague } = ctx;
  return (
    <>
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-white">Leagues</h1>
        <button data-testid="add-league-btn" onClick={() => setEditing({ ...EMPTY_LEAGUE })}
          className="inline-flex items-center gap-2 text-sm font-bold text-white bg-[#2563EB] hover:bg-[#1d4fd7] rounded-full px-5 py-2.5 transition-colors">
          <Plus size={16} /> Add League
        </button>
      </div>

      <div className="mt-8 space-y-3">
        {leagues.length === 0 && <p className="text-white/40 font-medium">No leagues yet. Add one to open registration.</p>}
        {leagues.map((lg) => (
          <div key={lg.id} data-testid={`admin-league-${lg.id}`} className="rounded-2xl bg-white/5 border border-white/10 p-5 md:p-6 flex flex-wrap items-center justify-between gap-4">
            <div>
              <div className="flex items-center gap-3">
                <span className={`inline-block rounded-full px-3 py-1 text-xs font-bold uppercase ${leagueStatusBadge(lg.status)}`}>
                  {lg.status.replace("_", " ")}
                </span>
                <p className="text-lg font-bold text-white">{lg.name}</p>
              </div>
              <p className="mt-2 text-sm font-medium text-white/50">
                ${lg.price} · {lg.spots_filled}/{lg.spots_total} filled · {lg.start_date || "Start TBD"}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button data-testid={`edit-league-${lg.id}`} onClick={() => setEditing({
                ...lg,
                age_groups: joinList(lg.age_groups),
                divisions: joinList(lg.divisions),
                included: joinList(lg.included),
                tracked: joinList(lg.tracked),
              })} className="inline-flex items-center gap-1.5 text-sm font-bold text-white/70 hover:text-white border border-white/15 rounded-full px-4 py-2 transition-colors">
                <Pencil size={14} /> Edit
              </button>
              <button data-testid={`delete-league-${lg.id}`} onClick={() => deleteLeague(lg.id)}
                className="inline-flex items-center gap-1.5 text-sm font-bold text-red-300 hover:text-red-200 border border-white/15 rounded-full px-4 py-2 transition-colors">
                <Trash2 size={14} /> Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
